import {VWCarModel} from './surveyResponse';

export interface jsonMarkdown {
  name: '##name##';
  model: '##model##';
  model_km: '##model_km##';
  weekly_basis: '##weekly_basis##';
  total_chargers: '##total_chargers##';
}

export const JSONMARKDOWN = {
  name: '##name##',
  model: '##model##',
  model_km: '##model_km##',
  weekly_basis: '##weekly_basis##',
  total_chargers: '##total_chargers##',
};

export const MODELKMS = {
  id4: '553km',
  id5: '567km',
  id4gtx: '527km',
  id5gtx: '529km',
  touareg: '51km',
  id4Andid5: '565km',
  id4gtxAndid5gtx: '565km',
};

export const VWCARMODELLABELS: Record<VWCarModel, string> = {
  id4: 'ID. 4 Pro',
  id5: 'ID. 5 Pro',
  id4Andid5: 'ID. 4 Pro & ID. 5 Pro',
  id4gtx: 'ID. 4 GTX',
  id5gtx: 'ID. 5 GTX',
  id4gtxAndid5gtx: 'ID. 4 GTX & ID. 5 GTX',
  amarok: 'Amarok',
  idBuzz5: 'ID. Buzz 5 Seater',
  idBuzz7: 'ID. Buzz 7 Seater',
  idBuzzCargo: 'ID. Buzz Cargo',
  touareg: 'Touareg R eHybrid',
};
